import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Chip, ChipAction, Sidebar } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { RenameDocumentDialog } from 'app/domains/documents';
import { useDocumentMetadata } from './DocumentMetadataProvider';
export function DocumentNameChip() {
    const { data } = useDocumentMetadata();
    const [active, setActive] = useState(false);
    const { systemData, accessLevel } = data;
    const { name } = systemData;
    const restricted = accessLevel !== 'full';
    const toggleAction = () => setActive(!active);
    return (<Fragment>
      <Sidebar.DefinitionItem term={t({ message: 'Document name', comment: 'Label for document name' })}>
        <Sidebar.Definition>
          <Chip size="small" secondary={name} appearance="secondary" action={!restricted && (<ChipAction onClick={toggleAction}>
                  <Falcon icon="pencil"/>
                </ChipAction>)}/>
        </Sidebar.Definition>
      </Sidebar.DefinitionItem>

      {active && <RenameDocumentDialog onClose={() => setActive(false)}/>}
    </Fragment>);
}
